module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-newsletter u-relative u-bg--brand-gray"
  }, [_c('div', {
    staticClass: "c-newsletter__wrapper u-marg-x-auto u-flex u-block@lg u-w8of12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter__wrapper__right-side u-marg-x-auto u-w1of3 u-fit-w@lg"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-lg"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_c('app-input-email', {
    staticClass: "c-newsletter__wrapper__input u-relative u-marg-t-xs",
    attrs: {
      "label": "Your email",
      "label-for": "email"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-newsletter__wrapper__left-side u-relative u-w1of2 u-fit-w@lg"
  }, [_c('div', {
    staticClass: "c-newsletter__wrapper__title u-relative u-zindex--2 u-inline-block u-lheight--125p t-fweight--light u-color--white"
  }, [_c('span', [_vm._v("\n                    Join the\n                    "), _c('br'), _vm._v("\n                    mailing list\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter__wrapper__title__border u-absolute u-pos-bl u-bg--white"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-content is-white u-color--white"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("Join the mailing list text: Leave us your email and keep you updated on the launch of PRAX.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3931830a"}!./src/scripts/components/app-newsletter/template.html
// module id = 461
// module chunks = 0